import { render, staticRenderFns } from "./HomeBannerFooter.vue?vue&type=template&id=52ffdd77&scoped=true&"
import script from "./HomeBannerFooter.vue?vue&type=script&lang=js&"
export * from "./HomeBannerFooter.vue?vue&type=script&lang=js&"
import style0 from "./HomeBannerFooter.vue?vue&type=style&index=0&id=52ffdd77&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ffdd77",
  null
  
)

export default component.exports